/** One implementation: the helper lives with the ported models (it is used from many of them). */
import { toIsoDate } from '@/core/models/practice.models';

export { toIsoDate };

/**
 * The message to show when a date range runs backwards, or null when it is fine (or either end is still empty).
 * Accepts the same values the date fields emit (dayjs, Date, ISO string). `what` names the range in the message.
 */
export function dateRangeProblem(from: unknown, to: unknown, what = 'The date range'): string | null {
  const start = toIsoDate(from);
  const end = toIsoDate(to);
  if (!start || !end) return null;
  return end < start ? `${what} cannot end before it starts.` : null;
}
